






import React, { cloneElement } from 'react';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from "react";
import { FIELDS, STEPS } from '../utils/constants';
import { useFormStateContext } from '../utils/hooks';

// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

import {
  InputField,
  InputError,
  InputContainer,
  InputLabel,
  Flex,
  Button,
} from '../utils/styles';
import style from '../utils/style.css';
import axios from "axios";

// const checkEmailExistence = "http://localhost:8004/api/check-email-existence";

const checkEmailExistence = "/api/check-email-existence";



export const EmailForm  = () => {
  const { fields, setStep, updateFields } = useFormStateContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { email: fields.email } });

  // const goBack = () => {
  //   setStep(STEPS.CONTACT);
  // };
  
  const [emailExistMessage, checkEmailExist] = React.useState([]);
  
  const onSubmit = (data) => {
    axios.post(`${checkEmailExistence}`,data).then((response) => {
      if (response.data.success == false) 
      {
        checkEmailExist(response.data.message);
        //toast.success('Email sent successfully!');
      }
      else
      {
        updateFields(FIELDS.EMAIL, data.email);
        setStep(STEPS.CONTACT);
      }
    });
    
  };

  const onError = (errors, event) => {
    console.log(errors);
    console.log(event);
  };

  return (
    <div className="base-form">
      <form onSubmit={handleSubmit(onSubmit, onError)}>
      <div className="f-container">
      <div className='button-back button-back1'>

          <h4>Start with your email</h4>
        </div> 
      
        <label className='name'>Email</label>
          <InputContainer style={{ margin: '10px 0'}} error={errors.email}>
            <Flex alignItems="center" justifyContent="space-between">
              <InputLabel children="" />
              {errors.email && <InputError children={errors.email.message} />}
              {(!errors.email && emailExistMessage )&& <InputError children={emailExistMessage} />}
            </Flex>
            <InputField
              id="email"
              type="email"
              placeholder='abcd@gmail.com'
              {...register('email', {
                required: 'Email is required',
              })}
            />
          </InputContainer>

          <div className="terms5 terms1">
              {/* <br /> */}
            <p > By submitting your email you will agree on express registration and the following data  processing  <a href='http://casino.tecpiniondev.com/Terms-of-Use' target="_blank">terms</a></p>
            {/* <br /> /}
            {/* <p>You can also register <a href='/'>manually</a></p> */}
           
            {/* <p>Have an account? <a href='/?login'>Log in</a></p>  */}
            
        </div>
          {/* <Flex justifyContent="flex-end">
            <Button
              type="button"
              children="Back"
              secondary
              style={{ margin: '0 10px' }}
              onClick={goBack}
            />
            <Button children="Next" />
          </Flex> */}
          <div className='button-next'>
           <Button children="Next" >Press <span className="enter">Enter</span>  <i class="fa fa-angle-right" aria-hidden="true"></i></Button>
          </div>
          <p class="hidden-xs">&nbsp;</p>
          <div class="terms5">
            <p className='text-center'> Already have an account with us? <a href="/login">Please Sign In</a>
            </p>
          </div>
        </div>
      </form>
    </div>
  );
};







